import React from 'react';
import { Typography } from '@mui/material';

// @desc Heading
const Heading = ({ content }) => {
  return <Typography variant='heading'>{content}</Typography>;
};

export default Heading;
